import { render, staticRenderFns } from "./tabcard.vue?vue&type=template&id=018d1d48&scoped=true&"
import script from "./tabcard.vue?vue&type=script&lang=js&"
export * from "./tabcard.vue?vue&type=script&lang=js&"
import style0 from "./tabcard.vue?vue&type=style&index=0&id=018d1d48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018d1d48",
  null
  
)

export default component.exports